import React from "react";

// A Pool Type's how-to-play heading and rules, from its config (src/poolTypes.js).
const Howto = ({ poolType }) => {
  const howto = poolType?.howto;
  const Rules = howto?.rules;
  return (
    <>
      <h1>{howto?.title}</h1>
      {Rules && <Rules />}
    </>
  );
};

export default Howto;
